import { useEffect, useState } from 'react';

const linkCols = [
  { title: '快速导航', links: [
    { href: '#hot', label: '今日热榜' },
    { href: '#fresh', label: '最新鲜瓜' },
    { href: '#cats', label: '瓜圈分类' },
    { href: '#faq', label: '玩法问答' },
  ]},
  { title: '粉丝服务', links: [
    { href: '#submit', label: '投稿爆料' },
    { href: '#crowd', label: '粉丝来稿' },
    { href: '#submit', label: '私信编辑部' },
  ]},
];

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <footer className="bg-background-200/70">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8 pt-14 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-vip-crown-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-2xl font-black text-foreground-950">
                吃瓜<span className="text-primary-500">日报</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              用一句话安利这份报纸：热榜由你投票、瓜圈按你口味、来稿能上头条。
              理性吃瓜，快乐冲浪，认真生活的你，声音不会被淹没。
            </p>
            <div className="mt-5 flex gap-2">
              {['ri-wechat-fill', 'ri-weibo-fill', 'ri-douban-fill', 'ri-mail-fill'].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label="关注吃瓜日报"
                  className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-lg text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={ic} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          {linkCols.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h3 className="text-sm font-bold text-foreground-950">{col.title}</h3>
              <ul className="mt-4 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="inline-flex items-center gap-1.5 text-sm text-foreground-700 transition-colors hover:text-primary-600"
                    >
                      <i className="ri-arrow-right-s-line text-primary-400" aria-hidden="true"></i>
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-300/60 pt-6 text-xs text-foreground-700">
          <p>© {new Date().getFullYear()} 吃瓜日报 · 理性吃瓜 · 快乐冲浪</p>
          <p className="flex items-center gap-1">
            <i className="ri-shield-check-line text-secondary-600" aria-hidden="true"></i>
            内容来自公开信息与粉丝来稿，传闻请理性看待、勿传播未经证实结论
          </p>
        </div>
      </div>

      {showTop && (
        <a
          href="#top"
          aria-label="返回顶部"
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
        </a>
      )}
    </footer>
  );
}